import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/checkout';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-151" data-mp="9llat1xpw6pm">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream-dark/50 via-cream to-cream -z-10" data-id="element-152" data-mp="4mrul1r1q1lr"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-153" data-mp="1274n7mu23c66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-154" data-mp="xb5w3rhcfg22">
          <div className="inline-block px-3 py-1 rounded-full border border-earth/20 bg-white text-earth font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6 shadow-sm" data-id="element-155" data-mp="3d2bj5ngruvuh">
            📚 Mega Pack Educación Agropecuaria en el Aula
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-slate-900" data-id="element-156" data-mp="3o7vkflb27pxt">
            Todo tu año de Producción Agropecuaria{' '}
            <span className="text-gold-gradient" data-id="element-157" data-mp="3e8wjkowjcyld">resuelto en una tarde.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-xl mb-4 sm:mb-6" data-id="element-158" data-mp="30hrjxmt646b1">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-159" data-mp="2hjf63nrba894"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7JuvtKLkyCEfog8D2oejWK/seguridad_e_higiene_(1).png" alt="Mega Pack Educación Agropecuaria en el Aula" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" data-mp="2hljb690y5daz" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-161" data-mp="n98ebq63t9oy">
          <p className="text-sm sm:text-lg md:text-xl text-slate-600 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-162" data-mp="1ayt710s27lbf">
            El sistema completo para planificar, enseñar y evaluar — listo para
            usar desde hoy.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-163" data-mp="x1nwoolbc0ad">
            <Button href={CHECKOUT_URL} onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-164" data-mp="x37ewkqj4les">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-600 font-medium" data-id="element-165" data-mp="1x786nshfdzw8">
            <div className="flex items-center gap-1.5" data-id="element-166" data-mp="26a9a1lewpcw7">
              <CheckCircle size={14} className="text-forest" data-id="element-167" data-mp="268fybrpfs2hc" />
              <span data-id="element-168" data-mp="2b0zduu7op7os">5 tomos principales</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-169" data-mp="2b2kbwtt7j8re">
              <CheckCircle size={14} className="text-forest" data-id="element-170" data-mp="2fz0yhjkrdf2d" />
              <span data-id="element-171" data-mp="2kynd9xg8j3da">4 bonos estratégicos</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-172" data-mp="2l1028ukeudzu">
              <CheckCircle size={14} className="text-forest" data-id="element-173" data-mp="2p1jylvx5tdkx" />
              <span data-id="element-174" data-mp="2tzlek7zagws6">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}